import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Modal, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { memoLogin } from '../../utils/LoginUtil'
import 'antd/dist/antd.css';
import './index.less';
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import axios from 'axios';


// 登录
export default function Login() {
  let history = useHistory();
  let [login, SetLogin] = useState(false);
  const langValue = useSelector(state => state.langList.value)

  useEffect(() => {
    // console.log("useEffect login:", login);

    if (!login) {
      // 判断用户浏览器
      var explorer = navigator.userAgent.toLowerCase();
      // console.log('explorer:', explorer);
      let type;
      let flag;
      //判断是否为Edg浏览器
      if (explorer.indexOf("edg") >= 0) {
        type = 'edg';
        flag = true;
      }
      //判断是否为Chrome浏览器
      else if (explorer.indexOf("chrome") >= 0) {
        type = 'chrome';
        flag = true;
      }
      //不是edg和chrome内核时，弹窗提示 
      else {
        flag = false;
      }
      // console.log('type:', type);
      if (flag == false) {
        message.destroy();
        Modal.info({
          content: '推荐使用Google Chrome或者Microsoft Edge浏览器，否则导入Excel文件时可能会出现问题。',
          zIndex: 2000 // 提示弹窗置于最上层
        });
      }
    }

    if (login) {
      history.push("/view");
    }

  }, [login])


  const onFinish = (values) => {
    // console.log('Login input onFinish: ', values);
    let { username, password } = values;

    //登录和后台交互
    (async function () {
      try {
        let { data } = await axios.post("/fund/login", { account: username, password: password });
        // console.log("login:", data);

        //交互提示
        if (data) {
          // console.log('pwds:', data.pwdIsStrong);
          sessionStorage.setItem('pwdIsStrong', data ?.pwdIsStrong);
          //密码强度
          if (data ?.pwdIsStrong == 0) {
            Modal.info({ content: langValue == 0 ? <>当前密码强度较弱，请修改密码后重新登录<br />The current password strength is weak. Please change your password and log in again</> : (langValue == 1 ? '当前密码强度较弱，请修改密码后重新登录' : 'The current password strength is weak. Please change your password and log in again'), okText: '知道了' });
          }
        }
        if (data ?.data) {
          //暂存登录信息
          memoLogin(data.data);
          sessionStorage.setItem('username', username);
          sessionStorage.setItem('langValue', 0)
          SetLogin(true);
        }

        // 暂存全部菜单路径
        if (data ?.allMenuPath) {
          sessionStorage.setItem('allMenuPath', data.allMenuPath);
        }

        // 暂存用户菜单路径
        if (data ?.userMenuPath) {
          sessionStorage.setItem('userMenuPath', data.userMenuPath);
        }

        // 判断环境
        if (data ?.env) {
          sessionStorage.setItem('env', data.env);
        }

      } catch (error) {
        if (error ?.response ?.data ?.msg) {
          const { msg, en_msg } = error.response.data
          // console.log('response:', error.response.data.msg);
          Modal.error({ content: langValue == 0 ? <>登录失败：{msg}<br />Login failed:{en_msg}</> : (langValue == 1 ? `登录失败：${msg}` : `Login failed:${en_msg}`) });
        } else {
          Modal.error({ content: '登录失败：' + error });
        }
      }

    })();
  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Login input Failed:', errorInfo);
  };


  return (

    <div className='login-wrapper'>

      {/*表单*/}
      <div className='form-wrapper'>
        {/*页面header*/}
        <div className='header-wrapper'>
          <div className='login-header'>
            <div className="logo"  >
              <img src="./images/logo.png" />
            </div>
            <div className="logo-title" >
              <div style={{ letterSpacing: '4.5px' }}
              >慈济捐款系统</div>
              <div style={{ fontSize: 16 }}>
                Tzuchi Donation System
              </div>
            </div>
          </div>

        </div>



        <Form
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: '请输入账号！Please enter account',
              },
            ]}
          >
            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="账号/account" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: '请输入密码！Please enter password',
              },
            ]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="密码/password"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button">
              登录/login
            </Button>
          </Form.Item>
        </Form>
      </div>

    </div>
  )
}
